// Type definitions for bank marketing

// Enums for bank marketing
export enum Job {
  ADMIN = 'admin.',
  BLUE_COLLAR = 'blue-collar',
  ENTREPRENEUR = 'entrepreneur',
  HOUSEMAID = 'housemaid',
  MANAGEMENT = 'management',
  RETIRED = 'retired',
  SELF_EMPLOYED = 'self-employed',
  SERVICES = 'services',
  STUDENT = 'student',
  TECHNICIAN = 'technician',
  UNEMPLOYED = 'unemployed',
  UNKNOWN = 'unknown',
}

export enum Marital {
  DIVORCED = 'divorced', // divorced or widowed
  MARRIED = 'married',
  SINGLE = 'single',
  UNKNOWN = 'unknown',
}

export enum Education {
  BASIC_4Y = 'basic.4y',
  BASIC_6Y = 'basic.6y',
  BASIC_9Y = 'basic.9y',
  HIGH_SCHOOL = 'high.school',
  ILLITERATE = 'illiterate',
  PROFESSIONAL_COURSE = 'professional.course',
  UNIVERSITY_DEGREE = 'university.degree',
  UNKNOWN = 'unknown',
}

export enum BinaryUnknown {
  NO = 'no',
  YES = 'yes',
  UNKNOWN = 'unknown',
}

export enum Contact {
  CELLULAR = 'cellular',
  TELEPHONE = 'telephone',
}

export enum Month {
  JAN = 'jan',
  FEB = 'feb',
  MAR = 'mar',
  APR = 'apr',
  MAY = 'may',
  JUN = 'jun',
  JUL = 'jul',
  AUG = 'aug',
  SEP = 'sep',
  OCT = 'oct',
  NOV = 'nov',
  DEC = 'dec',
}

export enum DayOfWeek {
  MON = 'mon',
  TUE = 'tue',
  WED = 'wed',
  THU = 'thu',
  FRI = 'fri',
}

export enum Poutcome {
  FAILURE = 'failure',
  NONEXISTENT = 'nonexistent',
  SUCCESS = 'success',
}

export enum ModelType {
  RANDOM_FOREST = 'random_forest',
  DECISION_TREE = 'decision_tree',
  KNN = 'knn',
  SVC = 'svc',
  LOGISTIC_REGRESSION = 'logistic_regression',
}

// Interface for bank marketing input
export interface BankMarketingInput {
  age: number;
  job: Job;
  marital: Marital;
  education: Education;
  default: BinaryUnknown;
  housing: BinaryUnknown;
  loan: BinaryUnknown;
  contact: Contact;
  month: Month;
  day_of_week: DayOfWeek;
  campaign: number;
  pdays: number;
  previous: number;
  poutcome: Poutcome;
  emp_var_rate: number;
  cons_price_idx: number;
  cons_conf_idx: number;
  euribor3m: number;
  nr_employed: number;
}

// Interface for model result
export interface BankMarketingModelResult {
  ml_type: ModelType;
  will_subscribe: boolean;
  subscription_probability: number | null;
}

// Interface for bank marketing response
export interface BankMarketingResponse extends BankMarketingInput {
  predictions: BankMarketingModelResult[];
}
